export default __webpack_public_path__ + "static/media/04_DAIF_Infra_01_01_end.832ccc9f.jpg";